Object.defineProperty(exports, '__esModule', { value: true });
var styles_1 = require('@material-ui/core/styles');
var React = require('react');
var recompose_1 = require('recompose');
var styles = function(theme) {
  return styles_1.createStyles({
    oilSteelBackgroundContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      backgroundColor: '#eeeeee',
      padding: 0,
      margin: 0,
      position: 'relative',
      zIndex: 100,
      minHeight: '100vh',
    },
    tritecnicalLogo: {
      position: 'absolute',
      top: '5%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 105,
      width: 350,
    },
  });
};
var TritecnicaBackground = function(props) {
  var classes = props.classes, children = props.children, hideLogo = props.hideLogo,
    imagesBaseUrl = props.imagesBaseUrl;
  return (React.createElement('div', { className: classes.oilSteelBackgroundContainer },
    !hideLogo && (React.createElement('img', {
      alt: 'tritecnica',
      src: imagesBaseUrl + 'tritecnica/assets/images/common/logo/logo.png',
      className: classes.tritecnicalLogo,
    })),
    children));
};
exports.default = recompose_1.compose(styles_1.withStyles(styles))(TritecnicaBackground);
//# sourceMappingURL=TritecnicaBackground.js.map
